// extracted by mini-css-extract-plugin
module.exports = {"container":"Services_container__1QlG5","btn":"Services_btn__2j_Mb","row":"Services_row__kdfG8","fadeIn":"Services_fadeIn__2d1vS","fadeIn2":"Services_fadeIn2__18LMA"};